import React from 'react'
import Yup from './../../../helpers/custom-yup'
import Button from '../../../components/buttons/buttons.component'
import styled from 'styled-components'
import StyledFlexContainer from './../../../components/containers/flex-container.component'
import discountCouponConstants from '../../../constants/discount-coupon.constants'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { breakpoints } from './../../../constants/breakpoits.constants'
import { CouponInput } from '../../../components/form-components/inputs.component'
import { toastActions } from '../../../actions'
import { CouponService } from './../../../services/coupon.service'
import { bindActionCreators } from 'redux'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import TicketSaleService from './../../../services/ticket-sale.service'
import { UserService } from './../../../services/user.service'
import { CalculationsService } from '../../../services'
import {
	ERROR_MSG_CALCULATED_VALUES,
	ALL_BUS_COMPANY,
	RoleConstants,
	PAYMENT_METHODS,
} from '@constants'
import TripDiscountHelper from '../../../helpers/trip-discount.helper'

class DiscountCouponComponent extends React.Component {
	constructor(props) {
		super(props)

		this.findCoupon = findCoupon.bind(this)
		this.renderFormik = renderFormik.bind(this)

		let couponPaymentMethod = 0
		if (props.paymentMethod === PAYMENT_METHODS.MUVICARD) {
			couponPaymentMethod = 2
		} else if (props.paymentMethod === PAYMENT_METHODS.PIX) {
			couponPaymentMethod = 3
		} else if (props.paymentMethod === PAYMENT_METHODS.CREDIT_CARD) {
			couponPaymentMethod = 1
		}

		this.state = {
			cleanValue: false,
			couponPaymentMethod,
		}

		this._isMounted = false
	}

	componentDidMount() {
		this._isMounted = true
		if (!this.props.orderNumber) {
			this.props.setIsCalculatingValues(true)
			this.applyAutomaticDiscountCoupon()
		}
	}

	componentWillUnmount() {
		this._isMounted = false // Atualizar flag ao desmontar
	}

	applyCoupon(promoCoupom) {
		this.props.setDiscountCoupon({
			isValid: true,
			code: promoCoupom.couponCode,
			discountPercentage: promoCoupom.discountPercentage,
			isPromotion: true,
		})

		this.refs.form.setFieldValue('code', promoCoupom.couponCode)

		this.getCalculatedValues(promoCoupom.discountPercentage)

		this.props.toastSuccess({
			message: `Cupom de desconto promocional de ${promoCoupom.discountPercentage}% de desconto foi aplicado!`,
		})

		this.props.setIsCalculatingValues(false)
	}

	async getCalculatedValues(discountPercentage) {
		const oldCalculatedValues = this.props.calculatedValues

		await this.props.setIsCalculatingValues(true)

		const values = {
			...oldCalculatedValues,
			couponDiscountPercent: discountPercentage || 0,
		}

		try {
			const { success, data } =
				await CalculationsService.getCalculatedValues(values)

			if (success) {
				this.props.setCalculatedValues({
					...values,
					...data,
					totalInterest: values.totalInterest,
					ticketsGoing: values.ticketsGoing,
					ticketsReturn: values.ticketsReturn,
				})
			} else {
				throw new Error()
			}
		} catch (error) {
			this.props.toastError({ message: ERROR_MSG_CALCULATED_VALUES })
		} finally {
			this.props.setIsCalculatingValues(false)
		}
	}

	getBusClass() {
		const busClass = [
			...this.props.calculatedValues.ticketsGoing.map(
				(ticket) => ticket.busClass
			),
			...this.props.calculatedValues.ticketsReturn.map(
				(ticket) => ticket.busClass
			),
		].join(', ')

		return busClass
	}

	getUnifiedBusCompany() {
		const { ticketsGoing, ticketsReturn } = this.props.calculatedValues

		let busCompany = this.props.busCompany
		let busCompanyWasChanged = false

		ticketsGoing.forEach((ticket) => {
			if (busCompany != ticket.busCompany) {
				if (!busCompanyWasChanged) {
					busCompany = ticket.busCompany
					busCompanyWasChanged = true
				} else {
					busCompany = ALL_BUS_COMPANY
					return
				}
			}
		})

		if (ticketsReturn.length) {
			ticketsReturn.forEach((ticket) => {
				if (busCompany != ticket.busCompany) {
					if (!busCompanyWasChanged) {
						busCompany = ticket.busCompany
						busCompanyWasChanged = true
					} else {
						busCompany = ALL_BUS_COMPANY
						return
					}
				}
			})
		}

		return busCompany
	}

	async applyAutomaticDiscountCoupon() {
		let allBusClass = this.getBusClass()

		if (!this._isMounted) return
		try {
			const params = {
				busCompany: this.props.busCompany,
			}

			if (this.props.user) {
				const { success, data } =
					await TicketSaleService.getAutomaticDiscountCoupon(params)

				if (success && data && data.code !== null) {
					this.refs.form.setFieldValue('code', data.code)
					this.findCoupon()
					return
				}
			}

			try {
				let busCompany = this.getUnifiedBusCompany()

				const { success, data } =
					await CouponService.findPromotionAutomaticallyCoupon(
						busCompany,
						this.props.boardingDate,
						this.props.hasReturn,
						allBusClass,
						this.state.couponPaymentMethod,
						this.props.originGoing,
						this.props.destinationGoing,
						this.props.calculatedValues.ticketsGoing,
						this.props.calculatedValues.ticketsReturn
					)

				if (success && data) {
					this.applyCoupon(data)
				}
			} catch (error) {
				throw new Error()
			}
		} catch (error) {
			this.props.toastWarning({
				message: 'Erro ao buscar ou aplicar cupons promocionais.',
			})
		} finally {
			this.props.setIsCalculatingValues(false)
		}
	}

	render() {
		return (
			<Formik
				ref="form"
				validationSchema={schema}
				render={this.renderFormik}
				initialValues={initialValues}
			/>
		)
	}
}

const schema = Yup.object().shape({
	code: Yup.string(),
})

const initialValues = {
	code: '',
}

function renderFormik(props) {
	const { isCpfChecked, user, paymentMethod } = this.props

	const isValidCPF = isCpfChecked || !!(user && user.cpf)

	// Meios de pagamento
	// Todos = 0,
	// Cartao = 1,
	// Muvicard = 2,
	// Pix = 3

	if (paymentMethod !== this.state.couponPaymentMethod) {
		let couponPaymentMethod = 0

		if (paymentMethod === PAYMENT_METHODS.MUVICARD) {
			couponPaymentMethod = 2
		} else if (paymentMethod === PAYMENT_METHODS.PIX) {
			couponPaymentMethod = 3
		} else if (paymentMethod === PAYMENT_METHODS.CREDIT_CARD) {
			couponPaymentMethod = 1
		}

		// Atualize o estado somente se necessário
		if (couponPaymentMethod !== this.state.couponPaymentMethod) {
			this.setState({ couponPaymentMethod })
		}
	}

	return (
		<StyledForm noValidate onSubmit={(e) => e.preventDefault()}>
			<StyledFlexContainer marginTop={0.1}>
				<CouponInput
					id="code"
					name="code"
					normalize
					{...props}
					maxLength={16}
					label="Código do cupom"
					className="col-3 coupon-input"
					style={{ textTransform: 'uppercase' }}
					toClean={this.state.cleanValue}
					disabled={!isValidCPF}
					setFieldValueHandler={() => {
						this.setState({
							cleanValue: false,
						})
					}}
				/>
				<Button
					id="apply-coupon"
					className="apply-coupon"
					primary
					type="button"
					onClick={this.findCoupon}
					disabled={!isValidCPF}>
					Aplicar
				</Button>
				{!user && (
					<span className="warning-message">
						*É necessário informar um CPF válido nos dados de{' '}
						<strong>comprador</strong> para aplicar um cupom de desconto.
					</span>
				)}
			</StyledFlexContainer>
		</StyledForm>
	)
}

const StyledForm = styled.form`
	.coupon-input {
		margin-bottom: 2.5rem;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-bottom: initial;
		}
	}
`

async function findCoupon() {
	const { toastWarning, resetDiscountCoupon, user } = this.props

	const isRequester = user && user.isRequester

	const {
		originGoing,
		destinationGoing,
		originReturn,
		destinationReturn,
		isCpfChecked,
	} = this.props

	if (
		!isRequester &&
		(TripDiscountHelper.checkInvalidRoutes(originGoing, destinationGoing) ||
			TripDiscountHelper.checkInvalidRoutes(originReturn, destinationReturn))
	) {
		toastWarning({
			message: 'Cupom de desconto não aplicável em mercado compartilhado.',
		})

		this.setState({
			cleanValue: isCpfChecked || !!(user && user.cpf),
		})

		this.props.setIsCalculatingValues(false)

		resetDiscountCoupon()

		return
	}

	const { code } = this.refs.form.state.values
	const { busCompany, boardingDate, hasReturn, cpf, calculatedValues } =
		this.props

	const isTicketSalePage =
		window.location.pathname === '/cliente/compra-de-passagem'

	let allBusClass = this.getBusClass()

	const { ticketsGoing, ticketsReturn } = calculatedValues

	let originGoingList = []

	ticketsGoing.map((ticket) => {
		originGoingList.push({
			originCity: ticket.originCity,
			destinationCity: ticket.destinationCity,
			tripDate: ticket.tripDate,
			busCompany: ticket.busCompany,
			busClass: ticket.busClass,
			busSeat: ticket.busSeat,
			destinationState: ticket.destinationState,
			originState: ticket.originState,
			provider: ticket.provider,
		})
	})

	const { data, success, errors } = await CouponService.find(
		code,
		cpf,
		discountCouponConstants.types.ticketPurchase,
		0,
		busCompany,
		boardingDate,
		hasReturn,
		allBusClass,
		this.state.couponPaymentMethod,
		originGoing,
		destinationGoing,
		ticketsGoing,
		ticketsReturn
	)

	const { familyDiscountParameters, familyDiscountApplied } = this.props

	if (success) {
		if (
			familyDiscountApplied &&
			isTicketSalePage &&
			familyDiscountParameters.percentDiscount >= data.discountPercentage
		) {
			toastWarning({
				message: 'Você já possui o Desconto Família aplicado',
			})
			resetDiscountCoupon()
		} else {
			this.props.setDiscountCoupon({
				isValid: true,
				code: data.couponCode,
				discountPercentage: data.discountPercentage,
			})

			await this.getCalculatedValues(data.discountPercentage)

			this.props.toastSuccess({
				message: `Seu cupom de ${data.discountPercentage}% de desconto foi aplicado!`,
			})
		}
	}

	if (errors) {
		this.props.setIsCalculatingValues(false)

		const message = errors.pop() || 'Cupom inválido'

		toastWarning({ message })
		resetDiscountCoupon()

		this.getCalculatedValues(0)
	}

	const message = errors.pop() || 'Cupom inválido'
	toastWarning({ message })
	resetDiscountCoupon()
}

const mapStateToProps = (store) => ({
	discountCoupon: store.ticketSale.DiscountCoupon,
	isEtapaPagamento: TicketSaleSelectors.getEtapaPagamento(store),
	orderNumber: store.ticketSale.orderNumber,
	paymentMethod: store.ticketSale.paymentMethod,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	familyDiscountParameters:
		TicketSaleSelectors.getFamilyDiscountParameters(store),
	familyDiscountApplied: store.ticketSale.familyDiscountApplied,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastSuccess: toastActions.success,
			toastWarning: toastActions.warning,
			toastError: toastActions.danger,
			setDiscountCoupon: TicketSaleCreators.setDiscountCoupon,
			resetDiscountCoupon: TicketSaleCreators.resetDiscountCoupon,
			setCalculatedValues: TicketSaleCreators.setCalculatedValues,
			setIsCalculatingValues: TicketSaleCreators.setIsCalculatingValues,
		},
		dispatch
	)

const DiscountCoupon = connect(
	mapStateToProps,
	mapDispatchToProps
)(DiscountCouponComponent)

export default DiscountCoupon
